import { jsx as _jsx } from "react/jsx-runtime";
import { LineIconButton } from '../../LineIconButton/LineIconButton';
export const TableCellButton = ({ text, icon, disabled, onClick }) => {
    return _jsx(LineIconButton, { icon: icon, disabled: disabled, onClick: onClick, "aria-label": text });
};
